import React, { useEffect, useState } from 'react'
import DynamicForm from '../../../../../customformComponent/customForm/DynamicForm';
import axiosInstance from '../../../../../services/api/API';
import { useLocation } from 'react-router-dom';
import Loader from '../../../../../customComponents/CustomLoader';


  const PurchaseSparePart = ({po_id,formData,  fetchPurchaseOrderDetails=()=>{},setFormData,vendorId,VendorID,fetchDepartments=()=>{},fetchPurchaseOrderList=()=>{},isEdit,toggleDrawer=()=>{}, activeComponent,podetailsID,bpid}) => {
 
  console.log("VendorID",VendorID);
  
    //const [ formData, setFormData ] = useState({})
    const [validationErrors, setValidationErrors] = useState({});
    const [loading, setLoading] = useState(false)
    const [ userTypedd, setUserTypedd ] = useState([])
    const [ logisticsVariant, setLogisticsVariant ] = useState([])
    const [sparePartOptions,setSparePartOptions]= useState([])
    const [sparePartDetails,setSparePartDetails]=useState([])
    const [ variantDetails, setVariantDetails ] = useState({})
    const [ totalPrice, setTotalPrice ] = useState(0)
    const [ unit, setUnit ] = useState([])
    const [taxsetDropdown,setTaxSet] = useState([])
    const [taxPercentage, setTaxPercentage] = useState(0);
      const userType = localStorage.getItem("UserType")
      const [variantId,setVariantId]= useState(0)
      const businessPartnerId = localStorage.getItem("business_partner_id")
      const token = localStorage.getItem("authToken");
     

      useEffect(() => {
        const variantId = formData?.variant;
       console.log("formData",formData);
       
        if (variantId) { // Ensure variantId is not undefined or null
          console.log(variantId, 'VariantId', formData);
          fetchVariantDD(variantId);
        }
      }, [formData?.variant]);
      const location = useLocation()
    console.log("location",location);
    
     // const vendorID=location?.state?.data?.vendor_onboard_id
     
    
      const fetchVariantDD = async (variantId) => {
        try{
          const response = await axiosInstance.post("/variant/ddlvariantbasedetails",{
            variant_id:variantId
          },{
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
    
          const fetchedData = response?.data?.data?.data[0]
          console.log(fetchedData, "FETCHEDDATAAAAAA")

          setFormData({
            ...formData,
            make_name: fetchedData.make_name,
            make_id:fetchedData?.make_id,
            model_id:fetchedData?.model_id,
            model_name: fetchedData.model_name,
            product_name: fetchedData.product_name,
            product_id: fetchedData.product_id,
            subproduct_name: fetchedData.subproduct_name,
            subproduct_id: fetchedData.subproduct_id,
            // unitprice:fetchedData?.exshowroom_price,
            // unit:fetchedData?.unit_id
            
          })
          setVariantDetails(fetchedData)

          const totalPriceData = response?.data?.data?.data[0]?.exshowroom_price
          setTotalPrice(totalPriceData)
          console.log(totalPriceData, "TOTALpRICEDATA")
    
        }catch(error){
          console.log(error, "error")
        }
      }
      useEffect(() => {
        userTypedropdown()
      },[])
      
      const userTypedropdown = async () => {
        try{
          const response = await axiosInstance.get("/bp-onboard/bplist",{
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
      
          const data = response.data.data.data
          const userTypeOptions = data.map(user => ({
            value: user.onboard_id,
            label:user.bp_name,
          }))
          setUserTypedd(userTypeOptions)
        }catch(error) {
          console.log(error)
        }
      }
    const handleFormSubmit = async (formData) => {
      const errors = {};
      let isValid = true;
  
      VehicleInputs.forEach((field) => {
        if (field.validation && field.validation.required) {
          if (!formData[field.name]) {
            errors[field.name] = "This field is required";
            isValid = false;
          }else if (field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
            errors[field.name] = field.validation.message;
            isValid = false;
          }
        }
      });
  
      if (!isValid) {
        setValidationErrors(errors);
        return;
      }
      try {
        setLoading(true)
        if(isEdit){
          const payload = {
            po_id:po_id,
          product_id:formData?.product_id,
          subproduct_id:formData?.subproduct_id,
          variant_id:formData?.variant,
          itemtype_id:1,
          itemtype:"S",
          item_id:formData?.spare_parts,  //// OTHER THEN   "itemtype":"V", Item_id is required
          unit_id:formData?.unitid,
          rate:formData?.unitprice,
          tax:taxPercentage/100,
          // total_price:String(formData?.total),
          taxset_id:formData?.taxset,
          taxset_amount:formData?.taxamount,
          quantity:formData?.goods_quantity,
          totalprice:formData?.finalamount,
          business_partner_id:bpid
              }
        
              // if (userType === "superadmin") {
              //   payload.business_partner_id = formData.business_partner_id;
              // } else {
              //   payload.business_partner_id = businessPartnerId;
              // }
        
              const response = await axiosInstance.patch(`/podetails/update/${podetailsID}`, payload,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                }
              }
            );
          
              console.log("Unit added successfully:", response.data);
              fetchPurchaseOrderList()
        fetchPurchaseOrderDetails();

              toggleDrawer();
        }
        else{ const payload = {
         
          po_id:po_id,
          product_id:formData?.product_id,
          subproduct_id:formData?.subproduct_id,
          variant_id:formData?.variant,
          itemtype_id:1,
          itemtype:"S",
          item_id:formData?.spare_parts,  //// OTHER THEN   "itemtype":"V", Item_id is required
          unit_id:formData?.unitid,
          rate:formData?.unitprice,
          // total_price:String(formData?.total),
          taxset_id:formData?.taxset,
          tax:taxPercentage/100,
          taxset_amount:formData?.taxamount,
          quantity:formData?.goods_quantity,
          totalprice:formData?.finalamount,
          business_partner_id:bpid
        }
            const response = await axiosInstance.post('/podetails/create', payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              }
            }
          );
        
            console.log("taxPercentage", taxPercentage);
            fetchPurchaseOrderList()
        fetchPurchaseOrderDetails();
              toggleDrawer();}

      } catch (error) {
        console.error('Error adding data:', error);
  
        console.error("Error submitting form:", error);
      } finally {
        setLoading(false);
      }
      console.log("clicked")
    };

    const VehicleInputs = [
     
        {
          name: "variant",
          label: "Variant",
          type: "dropdown",
          required: true,
          placeholder:"Select Variant",
          // disabled: fieldsdisabled,
          options:logisticsVariant,
    
          gridClass: "col-lg-12",
        },
        {
          name: "make_name",
          label: "Make",
          type: "text",
          placeholder:"Select Make",
          // options: logisticComapanies,
          // disabled: fieldsdisabled,
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "model_name",
          label: "Model",
          type: "text",
          placeholder:"Select Model",
          // options: logisticComapanies,
          // disabled: fieldsdisabled,
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "product_name",
          label: "Product",
          type: "text",
          placeholder:"Select Product",
          // options: logisticComapanies,
          // disabled: fieldsdisabled,
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "subproduct_name",
          label: "SubProduct",
          type: "text",
          placeholder:"Select Subproduct",
          // options: logisticComapanies,
          // disabled: fieldsdisabled,
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "spare_parts",
          label: "Spare Parts",
          type: "dropdown",
          options:sparePartOptions,
          required: true,
          validation:{required:true},
          gridClass: "col-lg-6",
        },
        {
          name: "unit",
          label: "Unit",
          placeholder:"Select Unit",
          type: "text",
         
          // disabled: fieldsdisabled,
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
       
       
      
        {
          name: "unitprice",
          label: "Price",
          type: "text",
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "taxset",
          label: "Tax Set",
          type: "dropdown",
          options:taxsetDropdown,
          required: true,
          validation:{required:true},
          gridClass: "col-lg-6",
        },
        {
          name: "goods_quantity",
          label: "Goods Quantity",
          placeholder:"Select Goods Quantity",
          type: "text",
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "taxamount",
          label: "Tax Amount",
          type: "text",
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },
        {
          name: "finalamount",
          label: "Total",
          type: "text",
          validation: { required: true },
          required: true,
          gridClass: "col-lg-6",
        },


    ]
    useEffect(() => {
      fetchLogisticsBaseVariant()
      fetchTaxSetDropdown();
     
  },[])

  useEffect(()=>{
    
if(formData?.taxset || formData?.goods_quantity){
  const selectedTaxSet = taxsetDropdown?.find(option => option?.value === formData?.taxset);
  const totalprice=formData?.unitprice * formData?.goods_quantity
  const validTotalPrice = isNaN(totalprice) ? 0 : totalprice;
  console.log("totalprice",totalprice);
  
  const taxPercent = selectedTaxSet ? selectedTaxSet.tax_percent : 0;
  const taxAmount = totalprice  * (taxPercent/100)
  const validTaxAmount = isNaN(taxAmount) ? 0 : taxAmount;
  setTaxPercentage(taxPercent);
  setFormData({
    ...formData,taxamount:parseFloat(validTaxAmount).toFixed(1),finalamount:(parseFloat(validTotalPrice) + parseFloat(validTaxAmount)).toFixed(1)
  })
}
  },[formData?.taxset,formData?.goods_quantity])
  
  const fetchTaxSetDropdown = async () => {
    try {
      const response = await axiosInstance.post('/tax/ddltax', {
       
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data
      console.log(formattedData, "VARIANTDATA")

      const variantData = formattedData.map(data => ({
        value:data.ID,
        label:data.NAME,
        tax_percent:data?.tax_percent
        
      }))

      setTaxSet(variantData)
      
    } catch (error) {
      console.error('Error fetching department list:', error);
    }
  };

    const fetchLogisticsBaseVariant = async () => {
      try {
        const response = await axiosInstance.post('/physicalstocktakeitem/ddllogisticbasevariant', {
          vendor_id: vendorId?vendorId : VendorID,
          //  vendor_id: VendorID,
          business_partner_id:bpid,
          itemtype:"S",
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }
        });
  
        const formattedData = response?.data?.data?.data
        console.log(formattedData, "VARIANTDATA")
  
        const variantData = formattedData.map(data => ({
          value:data.ID,
          label:data.NAME
        }))
  
        setLogisticsVariant(variantData)
        console.log(logisticsVariant, "LOGISTICSVARIANTID")
  
        console.log("response",response); 
      } catch (error) {
        console.error('Error fetching department list:', error);
      }
    };

    useEffect (()=>{
      if(formData?.variant){
        const fetchSparePartOptions = async() => {
          try {
          const sparepartResponse = await axiosInstance.post('/physicalstocktakeitem/ddllogisticbaseitem', {vendor_id:vendorId|| VendorID,
      itemtype:"S",
      variant_id:formData?.variant,
      business_partner_id:bpid }, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
          const spareOptions = sparepartResponse.data.data.data?.map(product => ({
            label:product.NAME,
            value: product.ID,
          }));
          setSparePartOptions(spareOptions);
        } catch (error) {
          console.log(error);
          
          
        }
      }
      fetchSparePartOptions()
      }
    },[formData?.variant])
    useEffect(() => {
      
     console.log("formData",formData);
     
      if (formData?.spare_parts) { // Ensure variantId is not undefined or null
       
        fetchSparePartDetails(formData?.spare_parts);
      }
    }, [formData?.spare_parts]);

    
        const fetchSparePartDetails = async () => {
          try {
            const token = localStorage.getItem("authToken");
            
            const response = await axiosInstance.post('/item/ddllogisticitembase', {
            stock_type:"S",// for Spare-Parts//2 for accessory
            business_partner_id: bpid,
            item_id:formData?.spare_parts,
            vendor_id:vendorId || VendorID


            }, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            });
                const sparepartdetails = response?.data?.data?.data[0]
            setSparePartDetails(sparepartdetails)
            console.log("sparePartDetails",sparepartdetails);
            
        setFormData({
          ...formData,
          unit:sparepartdetails?.unit,
          unitid:sparepartdetails?.unit_id,
          unitprice:sparepartdetails?.purchase_price,  
        
        })
          } catch (error) {
            console.error("Error fetching variant options:", error);
          }
        };
 
    useEffect(() => {
      const fetchSparePartExistingDetails = async () => {
        console.log("api called");
        
        try {
          const response = await axiosInstance.get(`/podetails/edit/${podetailsID}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
    
          if (response.status === 200) {

            const vehicleData = response.data.data;
            console.log("sparepartdata",vehicleData);
            
        
    
            const transformedData = {
              variant: vehicleData?.variant_id,
              // productname: vehicleData.product_name,
              unit:vehicleData?.unit_id,
              taxset:vehicleData?.taxset_id,
              goods_quantity:vehicleData?.quantity,
              taxamount:vehicleData?.taxset_amount,
              finalamount:vehicleData?.totalprice,
             
              // goods_quantity:vehicleData?.good_qty,
              spare_parts: vehicleData?.item_id,
              // unitprice:String(vehicleData?.purchase_price)
             
            };
    
            setFormData(transformedData);
            fetchVariantDD(vehicleData.variant_id)
            fetchSparePartDetails(vehicleData?.spare_parts)          
            console.log("TransformedformData:", transformedData);
          } else {
            console.error('Failed to fetch vehicle data');
          }
        } catch (error) {
          console.error('Error fetching vehicle data:', error);
        }
      };
      console.log("activeComponent",activeComponent);
      
    
      if (isEdit && activeComponent==="spareparts") {
     
        fetchSparePartExistingDetails();
      }
    }, [isEdit]);
    

  return (
    <div>
    {loading ? (
      <Loader />
    ) : (
    <div>
        <DynamicForm
          formConfig={VehicleInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
            <button 
            onClick={() => {handleFormSubmit(formData)}}
            className="submit-btn"
            style={{marginTop:"15px", width:"85%"}}
            >
            Submit
            </button>
            </div>
      )}
    </div>
  )
}

export default PurchaseSparePart;